import { array, struct } from 'io-ts/Decoder';

import { Id as StageId } from '../../../../../job/stage/Id';
import { Id as StatusId } from '../../../../../job/status/Id';
import { Id as TransactionId } from '../../../../../transaction/Id';

export const Request = array(
	struct({
		transactionId: TransactionId,
		stageId: StageId,
		statusId: StatusId,
	})
);
